export class BufferAttribute {
    location;
    buffer;
    vertices;
    offset;
    stride;
    constructor({ location, vertices, offset, stride = 0 }) {
        this.location = location;
        this.vertices = vertices;
        this.offset = offset;
        this.stride = stride;
    }
    setBuffer(buffer) {
        this.buffer = buffer;
    }
    bindToArrayBuffer(gl) {
        gl.vertexAttribPointer(this.location, this.vertices, gl.FLOAT, false, this.stride, this.offset);
    }
}
